import { useTracking } from '@change-corgi/core-react/tracking';

import { useLocalPageData } from '#src/app/pages/local/details/pageContext';

type Result = ModelHookResult<{
	displayName: string;
	location?: {
		lat: number;
		lng: number;
	};
	trackSAP: () => void;
}>;

export function usePageHeading(): Result {
	const {
		data: { displayName, lat, lng },
	} = useLocalPageData();

	const track = useTracking();

	return {
		data: {
			displayName,
			location: lat && lng ? { lat, lng } : undefined,
			trackSAP: () => {
				void track('local_sap_click_top');
			},
		},
	};
}
